import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import Modal from 'react-responsive-modal'
import cn from 'classnames'
import Button from '../../components/Button'
import { getSubjectsByYearStudyCourses, saveSubjectsByYearStudy } from '../../actions/subjectsByYearStudy'
import styles from './styles.module.css'

export default function SubjectsByYearStudyModal({ trid, level, closeModal, onSaved }) {

  const dispatch = useDispatch()
  const { courses } = useSelector(state => state.subjectsByYearStudy)

  const [checked, setChecked] = useState({})
  const [search, setSearch] = useState('')
  const [saving, setSaving] = useState(false)

  useEffect(() => {
    dispatch(getSubjectsByYearStudyCourses(trid, level))
  }, [trid, level, dispatch])

  useEffect(() => {
    courses && setChecked(Object.fromEntries(courses.map(c => [c.cid, c.linked])))
  }, [courses])

  const query = search.trim().toLowerCase()
  const filtered = courses?.filter(c => !query || c.title?.toLowerCase().includes(query))

  const toggle = (cid) => setChecked(prev => ({ ...prev, [cid]: !prev[cid] }))

  const handleSave = async () => {
    const cid_list = Object.entries(checked)
      .filter(([, on]) => on)
      .map(([cid]) => Number(cid))
    setSaving(true)
    const ok = await dispatch(saveSubjectsByYearStudy({ trid, level, cid_list }))
    setSaving(false)
    if (ok) onSaved(level)
  }

  return (
    <Modal
      open
      onClose={closeModal}
      center
      closeOnOverlayClick={true}
      closeOnEsc={true}
      showCloseIcon={false}
      animationDuration={1}
      classNames={{ modal: styles.compoundModal }}
    >
      <h2 className={styles.modalTitle}>Составление учебного плана</h2>
      <div className={styles.modalSub}>{level} год обучения</div>

      <div className={styles.modalSearch}>
        <input
          type='text'
          placeholder='Поиск предмета'
          value={search}
          onChange={e => setSearch(e.target.value)}
          autoComplete='off'
        />
      </div>

      <div className={styles.pickList}>
        {courses
          ? filtered.length
            ? filtered.map(c => (
              <label key={c.cid} className={cn(styles.pickItem, { [styles.pickItemOn]: checked[c.cid] })}>
                <input
                  type='checkbox'
                  checked={!!checked[c.cid]}
                  onChange={() => toggle(c.cid)}
                />
                {c.title}
              </label>
            ))
            : <div className={styles.pickEmpty}>ничего не найдено</div>
          : <div className={styles.pickEmpty}>Загрузка...</div>}
      </div>

      <div className={styles.modalFooter}>
        <Button mode='white' onClick={handleSave} loading={saving} disabled={saving || !courses}>Сохранить</Button>
        <Button mode='white' onClick={closeModal}>Закрыть</Button>
      </div>
    </Modal>
  )
}
